// Shared refund helpers for AdminTransactions + AdminRefunds

export function isRazorpayPaymentId(id) {
  return /^pay_[a-zA-Z0-9]+$/i.test(String(id || '').trim());
}

export function isBackfillTxn(t) {
  if (!t) return false;
  const gw = String(t.gatewayProvider || '').toLowerCase();
  const order = String(t.gatewayOrderId || '');
  return gw === 'backfill' || /^BACKFILL_/i.test(order);
}

/** Reconciled row with no live pay_… id — manual settlement only. */
export function isSyntheticBackfill(t) {
  return isBackfillTxn(t) && !isRazorpayPaymentId(t?.gatewayPaymentId);
}

/** UI status — Razorpay parity; never show backfill as gateway "Credited". */
export function displayTxnStatus(row) {
  if (!row) return '—';
  if (row.displayStatus) return row.displayStatus;
  if (isSyntheticBackfill(row)) {
    if (row.status === 'credited') return 'manual_credited';
    return 'historical';
  }
  if (row.status === 'historical') return 'historical';
  if (row.razorpayStatus) {
    const rs = String(row.razorpayStatus).toLowerCase();
    if (row.type === 'refund') {
      if (rs === 'processed') return 'processed';
      if (rs === 'pending') return 'initiated';
      if (rs === 'failed') return 'failed';
    }
    if (row.type === 'payment' && rs === 'captured') return 'success';
  }
  return row.status || '—';
}

export function hasRazorpayGatewayId(row) {
  return isRazorpayPaymentId(row?.gatewayPaymentId) || /^rfnd_/i.test(String(row?.gatewayRefundId || ''));
}

export function pendingLinkedRefund(txn) {
  const linked = txn?.__refundLinked || [];
  return linked.find((r) => r.type === 'refund' && r.status === 'requested') || null;
}

/** Refund row to approve — never a payment row. */
export function refundActionTarget(row) {
  if (!row) return null;
  if (row.type === 'refund') return row;
  return pendingLinkedRefund(row);
}

/** Approve or settle a refund row (Razorpay API vs manual backfill). */
export async function settleRefundRow(r, { adminEmail, adminAPI }) {
  if (isSyntheticBackfill(r)) {
    const res = await adminAPI.markRefundCredited(r.transactionId, {
      adminEmail,
      note: 'Marked credited manually — historical backfill row (no Razorpay API)',
    });
    if (res.error && /404|not found|route/i.test(String(res.error))) {
      return {
        error:
          'Refund route not found on API Gateway. Add POST /admin/transactions/{proxy+} '
          + '→ HCEN_Admin_API, then retry Mark manual credit.',
      };
    }
    return res;
  }
  return adminAPI.initiateRefund(r.transactionId);
}
